<template>
    <div class="login-wrap">
        <i
            v-on:click="closeLogin"
            class="material-icons xl icon--dark-grey text-white link close-login">
            close
        </i>
        <p
            class="lead"
            v-if="message.length >= 1">
            {{ message }}
        </p>
        <div v-if="register === false && message.length === 0">
            <div v-if="result === false">
                <div class="grid-x grid-padding-x">
                    <div class="cell small-6">
                        <h5 class="text-right text-blue">
                            Log In
                        </h5>
                    </div>
                    <div class="cell small-6">
                        <h5>
                            <span
                                v-on:click="register = true"
                                class="text-light-grey link">Register</span>
                        </h5    >
                    </div>
                </div>
                <div class="grid-x grid-padding-x pad-top--xxxxl">
                    <div class="cell small-12">
                        <input
                            class="login-field"
                            v-model="email" v-on:focus="message = ''"
                            type="email" 
                            placeholder="Email address">
                    </div>
                </div>
                <p class="text-center pad-top">
                    <button
                        v-on:click="login"
                        class="ghost-button">Log In</button>
                </p>
            </div>
            <p class="pad-top--large text-center">
                No account?<br />
                <button
                    v-on:click="register = true"
                    class="ghost-button marg-top--xs">Register</button>
            </p>
        </div>
        <div
            class="pad-top"
            v-if="register === true && message.length === 0">
            <div class="grid-x grid-padding-x">
                <div class="cell small-12 medium-6">
                    <h5
                        class="text-right text-light-grey"
                        v-on:click="register = false">
                        Log In
                    </h5>
                </div>
                <div class="cell small-12 medium-6">
                    <h5>
                        <span
                            v-on:click="register = true"
                            class="text-blue link">Register</span>
                    </h5    >
                </div>
            </div>
            <select
                v-model="registration.title">
                <option selected value="0">Please choose</option>
                <option value="Mr">Mr</option>
                <option value="Mrs">Mrs</option>
                <option value="Miss">Miss</option>
                <option value="Ms">Ms</option>
                <option value="Dr">Dr</option>
            </select>
            <input
                class="login-field"
                v-model="registration.first_name"
                type="text"
                placeholder="First name">
            <input
                class="login-field"
                v-model="registration.last_name"
                type="text"
                placeholder="Last name">
            <input
                class="login-field"
                v-model="registration.email"
                type="email"
                placeholder="Email address">
            <input
                class="login-field"
                v-model="registration.phone"
                type="text"
                placeholder="Phone number">
            <p class="text-center pad-top--small">
                <button
                    v-on:click="registerNow"
                    class="ghost-button">Register</button>
            </p>
            <p v-if="message.length >= 1">{{ message }}</p>
            <p class="pad-top text-center text-blue">
                Already have an account<br />
                <button
                    v-on:click="register = false"
                    class="ghost-button marg-top--xs">Login</button>
            </p>
        </div>
    </div>
</template>

<script>
import axios from '../../axios';

export default {
    name: 'Login',
    data() {
        return {
            email: '',
            message: '',
            result: false,
            register: false,
            registration: {
                title: 0,
            },
        };
    },
    methods: {
        login() {
            const data = {
                email: this.email,
            };
            axios.post('/Users/requestToken.json', data)
                .then((response) => {
                    if (response.data.response === true) {
                        this.message = 'We have sent you a login link. Please check your email.';
                        this.result = true;
                    }
                    if (response.data.response === false) {
                        this.message = 'Sorry, we couldn\'t find that email. Please try again.';
                    }
                })
                .then((error) => {
                    if (error) {
                        this.message = 'Sorry, we couldn\'t find that email. Please try again.';
                    }
                });
        },
        closeLogin() {
            this.$store.dispatch('closeLogin');
            this.message = '';
        },
        registerNow() {
            const postData = this.registration;
            axios.post('/Users/register.json', postData)
            .then((response) => {
                if (response.data.response.email.length > 0) {
                    this.message = 'Thank you for registering. You are now logged in and can view your profile.';
                    // eslint-disable-next-line
                    console.log(response.data.response);
                    this.$store.dispatch('saveToken', response.data.response);
                } else {
                    this.message.saveSuccess = 'Sorry, that email already exists. Please try to login.';
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Auth/Login.vue